import { AfterViewInit, Component, inject, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { AssetType, RelatedAssetType } from '@app/core/model/entities/asset/asset-type';
import { AssetTypesService } from '@app/features/main/views/management/organization/asset-types/asset-types.service';
import {
  MatSelectAutocompleteComponent
} from '@app/shared/components/mat-select-autocomplete/mat-select-autocomplete.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'mat-select-asset-type-autocomplete',
  standalone: false,
  templateUrl: './mat-select-asset-type-autocomplete.component.html',
  styleUrl: './mat-select-asset-type-autocomplete.component.scss',
  providers: [{provide: MatFormFieldControl, useExisting: MatSelectAssetTypeAutocompleteComponent}, AssetTypesService]

})
export class MatSelectAssetTypeAutocompleteComponent extends MatSelectAutocompleteComponent<AssetType> implements AfterViewInit {
  private assetTypesService = inject(AssetTypesService);
  public hasData: boolean = false;
  public declare dataSourceInput$: Observable<AssetType[]>;

  public displayWith = (assetType: AssetType | RelatedAssetType): string => assetType?.toString();

  @Input() public entityType: EntityTypeEnum;

  public ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.dataSourceInput$ = this.assetTypesService.assetTypes$;
  }
}
